
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Row, Table,} from "reactstrap";
import EventService from "../../../services/eventService";
import AuditService from "../../../services/auditService";
import auditService from "../../../services/auditService";
import UtilService from "../../../services/utilService";
import HelperUtil from "../../../util/appUtil";

class LeadDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leadData: {},
            mergedData: []
        };
    }

    componentDidMount() {

        const {uniqueId} = this.props.match.params;
        auditService.listQuestions().then((questions) => {
            this.setState({surveyDetails: questions});
            AuditService.getAnswer(uniqueId).then((response) => {
                console.log(response)
                const mergedData = questions.map(question => {
                    const answer = response.answers.find(a => a.questionId === question.uniqueId);
                    return {
                        ...question,
                        score: answer ? answer.score : 0  // or 0 if you want a fallback score
                    };
                });
                console.log("mergedData", mergedData)
                this.setState({leadData: response, mergedData: mergedData});
            });
        });
    }

    render() {
        const {leadData} = this.state;
        return (
            <>
                <SimpleHeader
                    name="Details"
                    parentName="Leads"
                    heading="XareGrowth"

                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Details</h3>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols2Input"
                                        >
                                            Date Created
                                        </label>
                                        <p>{HelperUtil.formatDate(leadData?.dateCreated)}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            First Name
                                        </label>
                                        <p>{leadData.firstName}</p>
                                    </FormGroup>
                                </Col><Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Last Name
                                        </label>
                                        <p>{leadData.lastName}</p>
                                    </FormGroup>
                                </Col><Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Title
                                        </label>
                                        <p>{leadData.title || "N/A"}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Email
                                        </label>
                                        <p>{leadData.email || "N/A"}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Contact Number
                                        </label>
                                        <p>{leadData.contactNumber || "N/A"}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Registered User
                                        </label>
                                        <p>{leadData.registeredUser ? "YES" : "NO"}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            View Assessment
                                        </label>
                                        <br/>
                                        <Button size={"sm"}  color="default" outline onClick={()=> { window.location.href = `/self-assessment/${leadData.uniqueId}` }}>View</Button>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Country
                                        </label>
                                        <p>{leadData?.country || "N/A" }</p>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Container>
                <br/>
                <br/>
                <br/>
                <br/>
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Answers</h3>
                        </CardHeader>
                        <CardBody>

                            <Table bordered hover responsive>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Question</th>
                                    <th>Score</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.mergedData && this.state.mergedData.length > 0 ? (
                                    this.state.mergedData.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{item.question}</td>
                                            <td>{item.score}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">No data available</td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default LeadDetails;
